(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kb-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.getElementById('kb-back-to-top');
    if (!button || button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let queued = false;
    const chatGap = 0.7 * 96 / 2.54;
    const observed = new WeakSet();
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    function visibleRect(element) {
      if (!element) return null;
      const style = getComputedStyle(element);
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return null;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top >= 0 && rect.bottom <= window.innerHeight + 1 && rect.right > 0 && rect.left < window.innerWidth ? rect : null;
    }
    function observe(element) {
      if (element && resizeObserver && !observed.has(element)) {
        observed.add(element);
        resizeObserver.observe(element);
      }
      return element;
    }
    function update() {
      queued = false;
      const shown = window.scrollY > 20;
      if (!shown) {
        button.hidden = true;
        return;
      }
      const height = window.innerHeight;
      const width = window.innerWidth;
      let chatRect = null;
      for (const launcher of document.querySelectorAll('.kosbling-contact-fab')) {
        chatRect = visibleRect(launcher);
        if (chatRect) {
          observe(launcher);
          break;
        }
      }
      const buttonStyle = getComputedStyle(button);
      const safeBottom = parseFloat(buttonStyle.getPropertyValue('--kb-top-safe-bottom')) || 0;
      const safeRight = parseFloat(buttonStyle.getPropertyValue('--kb-top-safe-right')) || 0;
      let right = chatRect ? width - chatRect.left - chatRect.width / 2 - 22 : Math.max(24, safeRight + 12);
      let bottom = chatRect ? height - chatRect.top + chatGap : Math.max(24, safeBottom + 12);
      for (const obstacle of document.querySelectorAll('.kb-purchase, #PBarNextFrameWrapper')) {
        const rect = visibleRect(observe(obstacle));
        if (rect && rect.height < height * 0.45 && rect.bottom > height - 180 && rect.left < width - right && rect.right > width - right - 44) {
          bottom = Math.max(bottom, height - rect.top + 12);
        }
      }
      right = Math.min(Math.max(safeRight + 12, right), width - 56);
      bottom = Math.min(bottom, height - 56);
      button.style.setProperty('--kb-top-right', `${right}px`);
      button.style.setProperty('--kb-top-bottom', `${bottom}px`);
      button.hidden = false;
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, left: window.scrollX, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      schedule();
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['style', 'class', 'hidden'], childList: true });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-help-center"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kb-help-center')) {
  customElements.define('kb-help-center', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const input = this.querySelector('input[type="search"]');
      const clear = this.querySelector('[data-help-clear]');
      const status = this.querySelector('[data-help-status]');
      const empty = this.querySelector('[data-help-empty]');
      const articles = [...this.querySelectorAll('[data-help-article]')];
      const groups = [...this.querySelectorAll('[data-help-group]')];
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’‘]/g, "'");
      const records = articles.map(article => ({ article, text: normalize(article.textContent) }));
      this.querySelectorAll('[data-help-search]').forEach(el => { el.hidden = false; });
      articles.forEach(article => { article.querySelector('details').name = 'kb-help-questions'; });
      const filter = () => {
        const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        let count = 0;
        records.forEach(({ article, text }) => {
          const match = words.every(word => text.includes(word));
          article.hidden = !match;
          if (match) count++;
          else article.querySelector('details').open = false;
        });
        groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-help-article]')].some(article => !article.hidden); });
        this.querySelectorAll('[data-help-browse]').forEach(el => { el.hidden = words.length > 0; });
        clear.hidden = !words.length;
        empty.hidden = !words.length || count > 0;
        status.hidden = !words.length;
        status.textContent = words.length ? this.dataset.resultsTemplate.replace('[count]', String(count)) : '';
      };
      const reset = () => { input.value = ''; filter(); };
      input.addEventListener('input', filter, options);
      input.addEventListener('keydown', event => { if (event.key === 'Escape') { reset(); event.stopPropagation(); } }, options);
      clear.addEventListener('click', () => { reset(); input.focus(); }, options);
      const reveal = hash => {
        if (!hash || !hash.startsWith('#kb-help-')) return;
        const target = document.getElementById(hash.slice(1));
        if (!target || !this.contains(target)) return;
        reset();
        const details = target.matches('[data-help-article]') ? target.querySelector('details') : null;
        if (details) {
          articles.forEach(article => { article.querySelector('details').open = article.querySelector('details') === details; });
          details.querySelector('summary').focus({ preventScroll: true });
        } else target.querySelector('[tabindex="-1"]')?.focus({ preventScroll: true });
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#kb-help-"]');
        if (link) reveal(link.getAttribute('href'));
      }, options);
      window.addEventListener('hashchange', () => reveal(location.hash), options);
      reveal(location.hash);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kb-ready-copy"] && !Shopify.designMode) return;
  try {
    (() => {
  const bind = (scope) => {
    scope.querySelectorAll('[data-kb-ready-copy]').forEach((root) => {
      if (root.dataset.readyCopyBound) return;
      root.dataset.readyCopyBound = 'true';
      root.querySelectorAll('details[data-ready-copy-group]').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          root.querySelectorAll('details[data-ready-copy-group]').forEach((other) => {
            if (other !== item && other.dataset.readyCopyGroup === item.dataset.readyCopyGroup) other.open = false;
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document), { once: true });
  else bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
